var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolsPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_linear_5_1454)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 24C27 21.2386 29.2386 19 32 19C34.7614 19 37 21.2386 37 24C37 26.7614 34.7614 29 32 29C29.2386 29 27 26.7614 27 24ZM32 21C30.3431 21 29 22.3431 29 24C29 25.6569 30.3431 27 32 27C33.6569 27 35 25.6569 35 24C35 22.3431 33.6569 21 32 21Z",
    fill: "#3DE8CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9995 32C25.8353 31.3721 26.8742 31 28 31H36C37.1258 31 38.1647 31.3721 39.0005 32H42.6751C44.5114 32 46.0001 33.4887 46.0001 35.325V37C46.0001 37.5523 45.5523 38 45.0001 38H41V41C41 42.1046 40.1046 43 39 43H25C23.8954 43 23 42.1046 23 41V38H19.0002C18.448 38 18.0002 37.5523 18.0002 37V35.325C18.0002 33.4887 19.4889 32 21.3252 32H24.9995ZM30.8195 33L30.0559 37.5818C29.9763 38.0596 30.1323 38.5465 30.4748 38.8891L31.2929 39.7071C31.6834 40.0976 32.3166 40.0976 32.7071 39.7071L33.5252 38.8891C33.8677 38.5465 34.0237 38.0596 33.9441 37.5818L33.1805 33H36C37.6569 33 39 34.3431 39 36V41H25V36C25 34.3431 26.3431 33 28 33H30.8195Z",
    fill: "#3DE8CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9998 28.5C42.9998 29.8807 41.8806 31 40.4998 31C39.1191 31 37.9998 29.8807 37.9998 28.5C37.9998 27.1193 39.1191 26 40.4998 26C41.8806 26 42.9998 27.1193 42.9998 28.5Z",
    fill: "#3DE8CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28.5C26 29.8807 24.8807 31 23.5 31C22.1193 31 21 29.8807 21 28.5C21 27.1193 22.1193 26 23.5 26C24.8807 26 26 27.1193 26 28.5Z",
    fill: "#3DE8CA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_1454",
    x1: -19.7148,
    y1: 46.9283,
    x2: 39.3853,
    y2: -21.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#146658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29CCB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolsPeople);
export default __webpack_public_path__ + "static/media/schools-people.4c75690dd18506cc8cba8d824658ebbf.svg";
export { ForwardRef as ReactComponent };